import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Adjust = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.5 4.5C11.5 5.60457 10.6046 6.5 9.5 6.5C8.39543 6.5 7.5 5.60457 7.5 4.5M11.5 4.5C11.5 3.39543 10.6046 2.5 9.5 2.5C8.39543 2.5 7.5 3.39543 7.5 4.5M11.5 4.5H14M7.5 4.5H2M4.5 11.5C4.5 10.3954 5.39543 9.5 6.5 9.5C7.60457 9.5 8.5 10.3954 8.5 11.5M4.5 11.5C4.5 12.6046 5.39543 13.5 6.5 13.5C7.60457 13.5 8.5 12.6046 8.5 11.5M4.5 11.5H2M8.5 11.5H14"
        stroke={color || 'currentColor'}
      />
    </svg>
  ),
)
Adjust.displayName = 'Adjust'

export default Adjust
